/**
 *
 * @param {Object} state
 * @param {String} email
 */
const SET_WIZARD_INFO_DATA_REQUIRED = (state, payload) => {
  if (typeof(payload.data) === "boolean") {
    state.wizard.required.infos[payload.type] = payload.data
  } else {
    payload.data != ""
      ? (state.wizard.required.infos[payload.type] = payload.data)
      : (state.wizard.required.infos[payload.type] = "");
  }
};

/**
 *
 * @param {Object} state
 * @param {Object} payload
 */
const SET_WIZARD_INFO_OPTIONAL = (state, payload) => {
  payload.data != ""
    ? (state.wizard.optional.infos[payload.type] = payload.data)
    : (state.wizard.optional.infos[payload.type] = "");
};

/**
 *
 * @param {Object} state
 * @param {String} email
 */
const SET_WIZARD_FILL_PERCENT = (state, percent) => {
  percent !== "" ? (state.wizard.fillPercent = percent) : false;
};

/**
 *
 * @param {Object} state
 * @param {String} email
 */
 const SET_WIZARD_FILL_PERCENT_LAST = (state, percent) => {
  percent !== "" ? (state.wizard.fillPercentLast = percent) : false;
};

/**
 *
 * @param {Object} state
 * @param {Number} form id
 */
 const SET_STRAPI_FORM_ID = (state, strapiFormId) => {
  state.wizard.strapiFormId = strapiFormId;
};

/**
 *
 * @param {Object} state
 * @param {Object} form
 */
 const SET_STRAPI_FORM = (state, form) => {
  const formDatas = form[0]
  const questionsObjectKey = Object.keys(formDatas).filter(i => i.toLowerCase().indexOf('question') !== -1);
  const formQuestionsObject = form[0][questionsObjectKey]
  let questionsArray = [];

  formQuestionsObject.map((question) => {
    let filteredAnswers = Object.keys(question)
                            .filter(j => j.toLowerCase().indexOf('answer') === 0)
                            .filter(k => k.toLowerCase().indexOf('_value') === -1)
                            .reduce((prevArray, currentKey) => {
                              if (question[currentKey] !== null && question[currentKey] !== '') {
                                prevArray.push({
                                  letter: currentKey.split('_')[1],
                                  answer: question[currentKey],
                                  gameOverAnswer: question[`GameOver${currentKey}`],
                                  answerValue: question[`${currentKey}_value`]
                                });
                              }
                              return prevArray;
                            }, []);

    questionsArray.push({
      id: question.id,
      questionTitle: question.QuestionTitle,
      mcpDatabaseField: question.MCP_Database_Field,
      ...(question.QuestionTips ? { questionTips: question.QuestionTips} : {}),
        answers: filteredAnswers,
    })
  }); 


  state.wizard.form = questionsArray;
};

/**
 *
 * @param {Object} state
 * @param {Object} form
 */
const SET_FORM_ANSWERS = (state, payload) => {
  state.wizard.answers = payload;
}

const SET_WIZARD_OPTIN_DATA = (state, payload) => {
  state.wizard.required.infos.proxiserve_optin = payload;
}


export default {
  SET_WIZARD_INFO_DATA_REQUIRED,
  SET_WIZARD_FILL_PERCENT,
  SET_WIZARD_FILL_PERCENT_LAST,
  SET_WIZARD_INFO_OPTIONAL,
  SET_STRAPI_FORM_ID,
  SET_STRAPI_FORM,
  SET_FORM_ANSWERS,
  SET_WIZARD_OPTIN_DATA
};
